import React, { useState } from "react";
import ViewMapping from "../../RuleStandardPage/ViewMappingModal";
import styled from "styled-components/macro";
import FailureContextTable from "./FailureContextTable";
import { useParams } from "react-router-dom";
import Button from "../../../components/Button";

const ModalContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const ViewMappingContainer = styled.div`
  visibility: ${(props) => (props.showMapping ? "visible" : "hidden")};
  overflow: hidden;
  width: ${(props) => (props.showMapping ? "100%" : 0)};
`;

const FailureViewDetails = ({ apiData }) => {
  let params = useParams();
  const sourceId = params?.sourceId; //Source ID
  const refreshSummaryId = params?.reportId; // Report ID
  const failedRuleInstanceId = params?.failedRuleInstanceId; // Failed Rule Instance ID
  const failedRuleInstanceVersionId = params?.failedRuleInstanceVersionId
    ? Number(params?.failedRuleInstanceVersionId)
    : null; // Rule Instance Version for Table and Compare
  const failedRuleStandardVersionId = params?.failedRuleStandardVersionId; // Rule Standard Version

  const [showMapping, setShowMapping] = useState(false);

  return (
    <ModalContainer>
      <ViewMappingContainer showMapping={true}>
        <FailureContextTable
          dataSourceRefreshSummaryId={refreshSummaryId}
          ruleInstanceVersionId={failedRuleInstanceVersionId}
          apiData={apiData}
          showMapping={showMapping}
          setShowMapping={setShowMapping}
        />
      </ViewMappingContainer>
      {showMapping && (
        <div
          style={{
            borderLeft: "1px solid #ccc",
            marginLeft: "1rem",
            paddingRight: "1rem",
          }}
          onClick={() => setShowMapping((prevState) => !prevState)}
        ></div>
      )}

      <ViewMappingContainer showMapping={showMapping}>
        <div style={{ position: "absolute", right: 0, marginRight: "1.5rem" }}>
          <Button onClick={() => setShowMapping((prevState) => !prevState)}>
            Hide Policy
          </Button>
        </div>
        <ViewMapping
          sourceId={sourceId}
          instanceVersionId={failedRuleInstanceVersionId}
          ruleInstanceId={failedRuleStandardVersionId}
          ruleId={failedRuleInstanceId}
          editEnabled={false}
        />
      </ViewMappingContainer>
    </ModalContainer>
  );
};

export default FailureViewDetails;
